export default {
    baseurl:'https://rajdoot.biz/brm/api/'
}

// export default {
//     baseurl:'https://rajdooth.azurewebsites.net/api/'
// }